import { VideoPlayer } from '@belong/ui';
import { UnitListingDetailsModel } from 'src/api/models';

type VirtualTourProps = {
  home: UnitListingDetailsModel;
};

export function VirtualTour({ home }: VirtualTourProps) {
  return (
    <div className="flex size-full bg-black">
      <VideoPlayer
        playsInline
        autoplay={false}
        showPlayOverlay={false}
        // `!`: this tab is only in `getAvailableTabs`' list when the home has a
        // guided tour, and the URL was already read unconditionally.
        videoSrc={home.guidedTour!.url!}
        posterSrc=""
      />
    </div>
  );
}
